import template from './top-block.dot';
const topBlockTemplate = template.default ? template.default : template;
export { topBlockTemplate };
